import React from 'react';
import AccountManagement from '../components/AccountManagement';
import useAccountSettings from '../hooks/useAccountSettings';

const AccountManagementPage = ({
  subscriptionStatus,
  customerDetails,
  getAuthHeaders,
  fetchCustomerDetails,
  quotaUsage,
  loadingQuota,
  fetchQuotaUsage,
}) => {
  const {
    agentEnabled,
    archiveSoldItems,
    togglingAgent,
    togglingArchive,
    mailingListLoading,
    mailingListSubscribed,
    mailingListSubmitting,
    mailingListError,
    handleToggleAgent,
    handleToggleArchiveSoldItems,
    handleToggleMailingList,
    billingPortalLoading,
    billingPortalError,
    handleOpenBillingPortal,
  } = useAccountSettings({ getAuthHeaders, customerDetails, fetchCustomerDetails, fetchQuotaUsage });

  return (
    <AccountManagement
      subscriptionStatus={subscriptionStatus}
      customerDetails={customerDetails}
      quotaUsage={quotaUsage}
      loadingQuota={loadingQuota}
      agentEnabled={agentEnabled}
      archiveSoldItems={archiveSoldItems}
      togglingAgent={togglingAgent}
      togglingArchive={togglingArchive}
      mailingListLoading={mailingListLoading}
      mailingListSubscribed={mailingListSubscribed}
      mailingListSubmitting={mailingListSubmitting}
      mailingListError={mailingListError}
      onToggleAgent={handleToggleAgent}
      onToggleArchiveSoldItems={handleToggleArchiveSoldItems}
      onToggleMailingList={handleToggleMailingList}
      billingPortalLoading={billingPortalLoading}
      billingPortalError={billingPortalError}
      onOpenBillingPortal={handleOpenBillingPortal}
    />
  );
};

export default AccountManagementPage;
